export default {
  'it-IT': {
    writeAReview: 'Scrivi per primo una recensione',
    productCode: 'Codice prodotto: {code}',
    paymentsInfoKlarnaPayPal:
      'Paga in 3 rate da <strong>{amount}</strong> senza interessi. <strong>Klarna</strong>&nbsp;<strong><em>PayPal</em></strong>',
    paymentsInfoKlarna:
      'Paga in 3 rate da <strong>{amount}</strong> senza interessi. <strong>Klarna</strong>',
    paymentsInfoPayPal:
      'Paga in 3 rate da <strong>{amount}</strong> senza interessi. <strong><em>PayPal</em></strong>',
    paymentsInfoTextHeader:
      'Compra ora e paga in 3 rate da {amount} senza interessi.',
    paymentsInfoTextKlarnaPayPal:
      "<li>Aggiungi gli articoli al carrello.</li><li>Vai al checkout e scegli <strong>Klarna</strong> o <strong>PayPal</strong>.</li><li>Seleziona l'opzione per pagare in 3 rate senza interessi e inserisci i dati della tua carta di debito o credito.</li><li>Paga a rate. Il primo pagamento verrà effettuato quando l'ordine sarà evaso, e i rimanenti saranno effettuati ogni 30 giorni.</li>",
    paymentsInfoTextKlarna:
      "<li>Aggiungi gli articoli al carrello.</li><li>Vai al checkout e scegli <strong>Klarna</strong>.</li><li>Seleziona l'opzione per pagare in 3 rate senza interessi e inserisci i dati della tua carta di debito o credito.</li><li>Paga a rate. Il primo pagamento verrà effettuato quando l'ordine sarà evaso, e i rimanenti saranno effettuati ogni 30 giorni.</li>",
    paymentsInfoTextPayPal:
      "<li>Aggiungi gli articoli al carrello.</li><li>Vai al checkout e scegli <strong>PayPal</strong>.</li><li>Seleziona l'opzione per pagare in 3 rate senza interessi e inserisci i dati della tua carta di debito o credito.</li><li>Paga a rate. Il primo pagamento verrà effettuato quando l'ordine sarà evaso, e i rimanenti saranno effettuati ogni 30 giorni.</li>",
    paymentsInfoKlarnaPayPalFooter:
      'Ti preghiamo di notare che per alcuni acquisti potrebbe essere richiesto un pagamento iniziale più elevato. Consulta i <a class="link" href={link1} target="_blank">termini e condizioni di Klarna</a> e i <a class="link" href={link2} target="_blank">termini e condizioni di PayPal</a> per maggiori informazioni.',
    paymentsInfoKlarnaFooter:
      'Ti preghiamo di notare che per alcuni acquisti potrebbe essere richiesto un pagamento iniziale più elevato. Consulta i <a class="link" href={link} target="_blank">termini e condizioni di Klarna</a> per maggiori informazioni.',
    paymentsInfoPayPalFooter:
      'Ti preghiamo di notare che per alcuni acquisti potrebbe essere richiesto un pagamento iniziale più elevato. Consulta i <a class="link" href={link} target="_blank">termini e condizioni di PayPal</a> per maggiori informazioni.',
    paymentsInfoButtonClose: 'Chiudi',
    oneOrMoreComponentUnavailable:
      'Attenzione: uno o più prodotti non sono attualmente disponibili.',
    untilDepletion: 'Prodotto ad esaurimento',
    productKitIncludes: 'Il prodotto è composto da:',
    oneUnit: '1 articolo',
    fromXToY: 'da {x} a {y} unità',
    moreThan: '{x} o più unità',
    sizeChart: 'Guida taglie',
    select: 'Seleziona',
    selectSize: 'Seleziona la taglia',
    moreThanFive: 'Più di 5',
    moreThanTen: 'Più di 10',
    availability: {
      available: 'Disponibile',
      oneAvailable: 'Solo 1 disponibile',
      unavailable: 'Non disponibile',
      booking: 'Su ordinazione',
      comingSoon: 'Coming Soon',
      preorder: 'In preordine',
    },
    availabilityNote: {
      available:
        "<span class='prd-availability-colored'>{qty} disponibili.</span> {shippingMessage}",
      oneAvailable:
        "<span class='prd-availability-colored'>Solo 1 disponibile.</span> {shippingMessage}",
      unavailable:
        "<span class='prd-availability-colored'>Non disponibile.</span> Il prodotto richiesto non è attualmente disponibile.",
      qtyUnavailable:
        "<span class='prd-availability-colored'>Non disponibile.</span> La quantità richiesta non è attualmente disponibile.",
      optionUnavailable:
        "<span class='prd-availability-colored'>Non disponibile.</span> Il prodotto non è disponibile.",
      preorder:
        "<span class='prd-availability-colored'>In preordine.</span> Preordina ora il prodotto per riceverlo non appena sarà disponibile.<br />Data di arrivo prevista: {date}.",
      booking:
        "<span class='prd-availability-colored'>Disponibile in {days} giorni.</span> L'opzione selezionata è su ordinazione: <a class='link' href='{pathBase}aiuto/resi-e-rimborsi-intra-ue#product-on-request'>leggi le condizioni</a>.",
      soonAvailable:
        "<span class='prd-availability-colored'>Disponibile in {days} giorni.</span> L'opzione selezionata è su ordinazione: <a class='link' href='{pathBase}aiuto/resi-e-rimborsi-intra-ue#product-on-request'>leggi le condizioni</a>.",
      comingSoon:
        "<span class='prd-availability-colored'>Coming soon.</span> L'opzione arriverà prossimamente.<br />Data di arrivo prevista: {date}.",
      discontinued:
        "<span class='prd-availability-colored'>Fuori produzione.</span> Siamo spiacenti, ma il prodotto selezionato non viene più riassortito.",
      qtyDiscontinued:
        "<span class='prd-availability-colored'>Fuori produzione.</span> Siamo spiacenti, ma la quantità richiesta non verrà riassortita.",
    },
    selectionHint:
      'Non hai compilato i seguenti campi: <strong>{attr}</strong>.',
    logInToAddReassNotification:
      '<a href={url} class="prd-link">Effettua il login</a> per chiedere la notifica di riassortimento.',
    fastShippingHHMM: 'Ordina entro {hh} e {mm} e spediremo il tuo pacco oggi.',
    fastShippingHH: 'Ordina entro {hh} e spediremo il tuo pacco oggi.',
    fastShippingMM: 'Ordina entro {mm} e spediremo il tuo pacco oggi.',
    shippingDate: 'La tua spedizione partirà {date}.',
    time: {
      hour: 'ora',
      hours: 'ore',
      minute: 'minuto',
      minutes: 'minuti',
    },
    quantity: 'Quantità',
    buyOn: 'Compra ora su lordgun.com',
    addToCart: 'Aggiungi al carrello',
    unavailableNote:
      'La quantità richiesta non è attualmente disponibile. Vuoi sapere quando tornerà in stock?',
    activateReassortMentNotification: 'Attiva la notifica di riassortimento',
    freeShipping: 'Spedizione gratuita',
    freeShippings: 'Spedizioni Gratuite',
    freeShippingsNote: 'Per ordini superiori a {price}',
    securePayments: 'Pagamenti Sicuri',
    securePaymentsNote: 'Ci teniamo alla tua sicurezza',
    fastDispatch: 'Spedizioni Lampo',
    fastDispatchNote: 'In 24h se ordini entro le ore 14',
    automatedTranslation: {
      translated: 'Questo testo è stato tradotto automaticamente.',
      original: 'Per questo testo è disponibile una traduzione automatica.',
    },
    seeOriginal: "Clicca qui per leggere l'originale.",
    backToTranslation: 'Visualizza la traduzione automatica.',
    tabs: {
      description: 'Descrizione',
      techSpecs: 'Specifiche tecniche',
      technologies: 'Tecnologie',
      brandsGuides: 'Guida taglie',
      reviews: 'Recensioni',
      qAndA: 'Domande e risposte',
      top: 'Top',
      news: 'news',
    },
    isUseful: 'Utile?',
    yes: 'Sì',
    no: 'No',
    vulgar: 'Volgare',
    spam: 'Spam',
    useless: 'Inutile',
    send: 'Invia',
    cart: {
      label: {
        available: 'Prodotto aggiunto al carrello!',
        soonAvailable: 'Prodotto aggiunto al carrello!',
        oneAvailable: 'Prodotto aggiunto al carrello!',
        unavailable: 'Notifica di riassortimento aggiunta!',
        qtyUnavailable: 'Notifica di riassortimento aggiunta!',
        optionUnavailable: '',
        preorder: 'Prodotto aggiunto al carrello!',
        booking: 'Prodotto aggiunto al carrello!',
        comingSoon: 'Prodotto aggiunto al carrello!',
        discontinued: '',
      },
      itemsInCart: 'Articoli nel carrello',
      totalPrice: 'Totale carrello',
      goToCart: 'Visualizza il carrello',
      goToNotifications: 'Visualizza le tue notifiche',
      continueShopping: 'Prosegui con gli acquisti',
    },
    genericError: 'Oops… Si è verificato un errore!',
    productRelations: 'Prodotti correlati',
  },
  'fr-FR': {
    writeAReview: 'Soyez le premier à donner un avis',
    productCode: 'Code produit: {code}',
    paymentsInfoKlarnaPayPal:
      'Payez en 3 fois à partir de <strong>{amount}</strong> sans frais. <strong>Klarna</strong>&nbsp;<strong><em>PayPal</em></strong>',
    paymentsInfoKlarna:
      'Payez en 3 fois à partir de <strong>{amount}</strong> sans frais. <strong>Klarna</strong>',
    paymentsInfoPayPal:
      'Payez en 3 fois à partir de <strong>{amount}</strong> sans frais. <strong>Klarna</strong>',
    paymentsInfoTextHeader:
      'Achetez dès maintenant et payez en 3 fois à partir de {amount} sans frais.',
    paymentsInfoTextKlarnaPayPal:
      "<li>Ajoutez les articles au panier.</li><li>Allez au checkout et choisissez <strong>Klarna</strong> ou <strong>PayPal</strong>.</li><li>Sélectionnez l'option pour payer en 3 fois sans frais et insérez les données de votre carte de débit ou de crédit.</li><li>Payez en plusieurs fois. Le premier paiement sera effectué quand la commande sera traitée et ceux restant seront effectués tous les 30 jours.</li>",
    paymentsInfoTextKlarna:
      "<li>Ajoutez les articles au panier.</li><li>Allez au checkout et choisissez <strong>Klarna</strong>.</li><li>Sélectionnez l'option pour payer en 3 fois sans frais et insérez les données de votre carte de débit ou de crédit.</li><li>Payez en plusieurs fois. Le premier paiement sera effectué quand la commande sera traitée et ceux restant seront effectués tous les 30 jours.</li>",
    paymentsInfoTextPayPal:
      "<li>Ajoutez les articles au panier.</li><li>Allez au checkout et choisissez <strong>PayPal</strong>.</li><li>Sélectionnez l'option pour payer en 3 fois sans frais et insérez les données de votre carte de débit ou de crédit.</li><li>Payez en plusieurs fois. Le premier paiement sera effectué quand la commande sera traitée et ceux restant seront effectués tous les 30 jours.</li>",
    paymentsInfoKlarnaPayPalFooter:
      'Nous vous prions de bien vouloir noter que pour certains achats un paiement initial plus élevé pourra être requis. Consultez les <a class="link" href={link1} target="_blank">termes et conditions de Klarna</a> et les <a class="link" href={link2} target="_blank">termes et conditions de PayPal</a> pour plus d\'informations.',
    paymentsInfoKlarnaFooter:
      'Nous vous prions de bien vouloir noter que pour certains achats un paiement initial plus élevé pourra être requis. Consultez les <a class="link" href={link} target="_blank">termes et conditions de Klarna</a> pour plus d\'informations.',
    paymentsInfoPayPalFooter:
      'Nous vous prions de bien vouloir noter que pour certains achats un paiement initial plus élevé pourra être requis. Consultez les <a class="link" href={link} target="_blank">termes et conditions de Paypal</a> pour plus d\'informations.',
    paymentsInfoButtonClose: 'Fermer',
    oneOrMoreComponentUnavailable:
      'Attention: un ou plusieurs produits sont actuellement indisponibles.',
    untilDepletion: 'Produit bientôt épuisé',
    productKitIncludes: 'Le produit est composé de:',
    oneUnit: '1 article',
    fromXToY: 'de {x} à {y} unités',
    moreThan: '{x} ou plusieurs unités',
    sizeChart: 'Guide des tailles',
    select: 'Sélectionner',
    selectSize: 'Sélectionner la taille',
    moreThanFive: 'Plus de 5',
    moreThanTen: 'Plus de 10',
    availability: {
      available: 'Disponible',
      oneAvailable: '1 seul de disponible',
      unavailable: 'Non disponible',
      booking: 'Sur commande',
      comingSoon: 'Coming Soon',
      preorder: 'En précommande',
    },
    availabilityNote: {
      available:
        "<span class='prd-availability-colored'>{qty} disponibles.</span> {shippingMessage}",
      oneAvailable:
        "<span class='prd-availability-colored'>1 seul de disponible.</span> {shippingMessage}",
      unavailable:
        "<span class='prd-availability-colored'>Non disponible.</span> Le produit sélectionné est actuellement indisponible.",
      qtyUnavailable:
        "<span class='prd-availability-colored'>Non disponible.</span> La quantité sélectionnée est actuellement indisponible.",
      optionUnavailable:
        "<span class='prd-availability-colored'>Non disponible.</span> Ce produit n'est pas disponible.",
      preorder:
        "<span class='prd-availability-colored'>En précommande.</span> Précommandez le produit maintenant pour le recevoir dès qu'il sera disponible.<br />Date d'arrivée prévue: {date}.",
      booking:
        "<span class='prd-availability-colored'>Disponible dans {days} jours.</span>L'option sélectionnée est sur commande: <a class='link' href='{pathBase}aide/retours-et-remboursements-union-européenne#product-on-request'>lire les conditions</a>.",
      soonAvailable:
        "<span class='prd-availability-colored'>Disponible dans {days} jours.</span>L'option sélectionnée est sur commande: <a class='link' href='{pathBase}aide/retours-et-remboursements-union-européenne#product-on-request'>lire les conditions</a>.",
      comingSoon:
        "<span class='prd-availability-colored'>Bientôt disponible.</span>L'option arrivera bientôt.<br />Date d'arrivée prévue: {date}.",
      discontinued:
        "<span class='prd-availability-colored'>En rupture de stock.</span> Nous sommes désolés, mais le produit sélectionné n'est plus en stock.",
      qtyDiscontinued:
        "<span class='prd-availability-colored'>En rupture de stock.</span> Désolé, la quantité sélectionnée n'est plus disponible",
    },
    selectionHint:
      "Vous n'avez pas rempli les champs suivants: <strong>{attr}</strong>.",
    logInToAddReassNotification:
      '<a href={url} class="prd-link">Connectez-vous</a> pour activer l\'alerte de réapprovisionnement.',
    fastShippingHHMM:
      "Il vous reste {hh} et {mm} pour que votre commande soit expédiée aujourd'hui.",
    fastShippingHH:
      "Il vous reste {hh} pour que votre commande soit expédiée aujourd'hui.",
    fastShippingMM:
      "Il vous reste {mm} pour que votre commande soit expédiée aujourd'hui.",
    shippingDate: 'La commande partira {date}.',
    time: {
      hour: 'heure',
      hours: 'heures',
      minute: 'minute',
      minutes: 'minutes',
    },
    quantity: 'Quantité',
    buyOn: 'Achetez maintenant sur lordgun.com',
    addToCart: 'Ajouter au panier',
    unavailableNote:
      'La quantité sélectionnée est actuellement indisponible. Voulez-vous être alerté de son retour en stock?',
    activateReassortMentNotification: "Activer l'alerte de réapprovisionnement",
    freeShipping: 'Livraison gratuite',
    freeShippings: 'Envoi Gratuit',
    freeShippingsNote: 'Pour toute commande supérieure à {price}',
    securePayments: 'Paiements Sécurisés',
    securePaymentsNote: 'Nous nous soucions de votre securité',
    fastDispatch: 'Expédition Rapide',
    fastDispatchNote: 'en 24h si vous passez commande avant 14h00',
    automatedTranslation: {
      translated: 'Ce texte a été traduit automatiquement.',
      original: 'Une traduction automatique est disponible pour ce texte.',
    },
    seeOriginal: "Cliquez ici pour lire l'original.",
    backToTranslation: 'Voir la traduction automatique.',
    tabs: {
      description: 'Description',
      techSpecs: 'Spécificités techniques',
      technologies: 'Technologies',
      brandsGuides: 'Guide des tailles',
      reviews: 'Commentaires',
      qAndA: 'Questions et réponses',
      top: 'Top',
      news: 'news',
    },
    isUseful: 'Utile?',
    yes: 'Oui',
    no: 'Non',
    vulgar: 'Grossier',
    spam: 'Spam',
    useless: 'Peu utile',
    send: 'Envoyer',
    cart: {
      label: {
        available: 'Produit ajouté au panier!',
        soonAvailable: 'Produit ajouté au panier!',
        oneAvailable: 'Produit ajouté au panier!',
        unavailable: 'Notification de réapprovisionnement ajoutée!',
        qtyUnavailable: 'Notification de réapprovisionnement ajoutée!',
        optionUnavailable: '',
        preorder: 'Produit ajouté au panier!',
        booking: 'Produit ajouté au panier!',
        comingSoon: 'Produit ajouté au panier!',
        discontinued: '',
      },
      itemsInCart: 'Produits dans le panier',
      totalPrice: 'Total du panier',
      goToCart: 'Voir le panier',
      goToNotifications: 'Voir vos notifications',
      continueShopping: 'Continuer mes achats',
    },
    genericError: "Oups… Une erreur s'est produite!",
    productRelations: 'Vous aimerez aussi...',
  },
  'es-ES': {
    writeAReview: 'Se el primero en escribir un comentario',
    productCode: 'Código producto: {code}',
    paymentsInfoKlarnaPayPal:
      'Paga en 3 plazos desde <strong>{amount}</strong> sin intereses. <strong>Klarna</strong>&nbsp;<strong><em>PayPal</em></strong>',
    paymentsInfoKlarna:
      'Paga en 3 plazos desde <strong>{amount}</strong> sin intereses. <strong>Klarna</strong>',
    paymentsInfoPayPal:
      'Paga en 3 plazos desde <strong>{amount}</strong> sin intereses. <strong><em>PayPal</em></strong>',
    paymentsInfoTextHeader:
      'Paga ahora en 3 plazos desde {amount} sin intereses.',
    paymentsInfoTextKlarnaPayPal:
      '<li>Añadir los artículos a la cesta de la compra.</li><li>Ir al checkout y elegir <strong>Klarna</strong> o <strong>PayPal</strong>.</li><li>Seleccionar la opción para pagar en 3 plazos sin intereses e introducir los datos de la tarjeta de crédito o de débito.</li><li>Pagar a plazos. El primer pago se realizará cuando se procese el pedido, mientras que el resto serán efectuados cada 30 días.</li>',
    paymentsInfoTextKlarna:
      '<li>Añadir los artículos a la cesta de la compra.</li><li>Ir al checkout y elegir <strong>Klarna</strong>.</li><li>Seleccionar la opción para pagar en 3 plazos sin intereses e introducir los datos de la tarjeta de crédito o de débito.</li><li>Pagar a plazos. El primer pago se realizará cuando se procese el pedido, mientras que el resto serán efectuados cada 30 días.</li>',
    paymentsInfoTextPayPal:
      '<li>Añadir los artículos a la cesta de la compra.</li><li>r al checkout y elegir <strong>PayPal</strong>.</li><li>Seleccionar la opción para pagar en 3 plazos sin intereses e introducir los datos de la tarjeta de crédito o de débito.</li><li>Pagar a plazos. El primer pago se realizará cuando se procese el pedido, mientras que el resto serán efectuados cada 30 días.</li>',
    paymentsInfoKlarnaPayPalFooter:
      'Hay que tener en cuenta que algunas compras pueden requerir un pago inicial más elevado. Consultar los <a class="link" href={link1} target="_blank">términos y condiciones de Klarna</a> y los <a class="link" href={link2} target="_blank">términos y condiciones de PayPal</a> para obtener mayor información.',
    paymentsInfoKlarnaFooter:
      'Hay que tener en cuenta que algunas compras pueden requerir un pago inicial más elevado. Consultar los <a class="link" href={link1} target="_blank">términos y condiciones de Klarna</a> para obtener mayor información.',
    paymentsInfoPayPalFooter:
      'Hay que tener en cuenta que algunas compras pueden requerir un pago inicial más elevado. Consultar los <a class="link" href={link} target="_blank">términos y condiciones de PayPal </a> pata obtener mayor información.',
    paymentsInfoButtonClose: 'Cerrar',
    oneOrMoreComponentUnavailable:
      'Atención: uno o más productos actualmente no están disponibles.',
    untilDepletion: 'Disponible hasta fin de existencias',
    productKitIncludes: 'El producto se compone de:',
    oneUnit: '1 artículo',
    fromXToY: 'de {x} a {y} unidades',
    moreThan: '{x} o más unidades',
    sizeChart: 'Guía a las tallas',
    select: 'Selecciona',
    selectSize: 'Seleccionar la talla',
    moreThanFive: 'Más de 5',
    moreThanTen: 'Más de 10',
    availability: {
      available: 'Displonible',
      oneAvailable: 'Solo 1 disponible',
      unavailable: 'No disponible',
      booking: 'Bajo pedido',
      comingSoon: 'Coming Soon',
      preorder: 'En précommande',
    },
    availabilityNote: {
      available:
        "<span class='prd-availability-colored'>{qty} displonibles.</span> {shippingMessage}",
      oneAvailable:
        "<span class='prd-availability-colored'>Solo 1 disponible.</span> {shippingMessage}",
      unavailable:
        "<span class='prd-availability-colored'>No disponible.</span> El producto indicado no está disponible.",
      qtyUnavailable:
        "<span class='prd-availability-colored'>No disponible.</span> La cantidad indicada actualmente no está disponible.",
      optionUnavailable:
        "<span class='prd-availability-colored'>No disponible.</span> El producto no está disponible.",
      preorder:
        "<span class='prd-availability-colored'>Bajo reserva.</span> Realiza el pedido ahora para recibir el producto tan pronto como esté disponible.<br />Fecha de llegada prevista: {date}.",
      booking:
        "<span class='prd-availability-colored'>Disponible en {days} días.</span>La opción seleccionada está bajo pedido: <a class='link' href='{pathBase}ayuda/cambios-y-devoluciones-ue#product-on-request'>lee las condiciones</a>.",
      soonAvailable:
        "<span class='prd-availability-colored'>Disponible en {days} días.</span>La opción seleccionada está bajo pedido: <a class='link' href='{pathBase}ayuda/cambios-y-devoluciones-ue#product-on-request'>lee las condiciones</a>.",
      comingSoon:
        "<span class='prd-availability-colored'>Coming soon.</span> La opción seleccionada llegará proximamente.<br />Fecha prevista de llegada: {date}.",
      discontinued:
        "<span class='prd-availability-colored'>Fuera de producción.</span> Lo sentimos, pero el producto seleccionado no volverá a estar disponible.",
      qtyDiscontinued:
        "<span class='prd-availability-colored'>Fuera de producción.</span> Lo sentimos, pero la cantidad indicada no volverá a ser disponible.",
    },
    selectionHint:
      'No se han rellenado los siguientes campos: <strong>{attr}</strong>.',
    logInToAddReassNotification:
      '<a href={url} class="prd-link">Realiza el login</a> para activar la alerta de reabastecimiento.',
    fastShippingHHMM:
      'Realiza el pedido antes de {hh} y {mm} y se enviará hoy mismo.',
    fastShippingHH: 'Realiza el pedido antes de {hh} y se enviará hoy mismo.',
    fastShippingMM: 'Realiza el pedido antes de {mm} y se enviará hoy mismo.',
    shippingDate: 'El envío se realizará {date}.',
    time: {
      hour: 'hora',
      hours: 'horas',
      minute: 'minuto',
      minutes: 'minutos',
    },
    quantity: 'Cantidad',
    buyOn: 'Compra ahora en lordgun.com',
    addToCart: 'Añadir a la cesta',
    unavailableNote:
      'La cantidad indicada actualmente no está disponible. ¿Quieres que te avisemos cuando haya stock?',
    activateReassortMentNotification: 'Activar la alerta de disponibilidad',
    freeShipping: 'Envío gratuito',
    freeShippings: 'Envío Gratis',
    freeShippingsNote: 'En pedidos superiores a {price}',
    securePayments: 'Pago Seguro',
    securePaymentsNote: 'Nos preocupamos por tu seguridad',
    fastDispatch: 'Envío rápido',
    fastDispatchNote: 'En 24h si realizas el pedido antes de las 14',
    automatedTranslation: {
      translated: 'Este texto ha sido traducido automáticamente.',
      original: 'Hay una traducción automática disponible para este texto.',
    },
    seeOriginal: 'Pulse aquí para leer el original.',
    backToTranslation: 'Ver traducción automática.',
    tabs: {
      description: 'Descripción',
      techSpecs: 'Especificaciones técnicas',
      technologies: 'Tecnologías',
      brandsGuides: 'Guía a las tallas',
      reviews: 'Comentarios',
      qAndA: 'Preguntas y respuestas',
      top: 'Top',
      news: 'news',
    },
    isUseful: '¿Util?',
    yes: 'Si',
    no: 'No',
    vulgar: 'Vulgar',
    spam: 'Spam',
    useless: 'Poco útil',
    send: 'Enviar',
    cart: {
      label: {
        available: '¡Producto añadido a la cesta!',
        soonAvailable: '¡Producto añadido a la cesta!',
        oneAvailable: '¡Producto añadido a la cesta!',
        unavailable: '¡Alerta de stock activada!',
        qtyUnavailable: '¡Alerta de stock activada!',
        optionUnavailable: '',
        preorder: '¡Producto añadido a la cesta!',
        booking: '¡Producto añadido a la cesta!',
        comingSoon: '¡Producto añadido a la cesta!',
        discontinued: '',
      },
      itemsInCart: 'Artículos en la cesta',
      totalPrice: 'Total cesta',
      goToCart: 'Ver la cesta',
      goToNotifications: 'Ver tus alertas',
      continueShopping: 'Seguir comprando',
    },
    genericError: 'Oops… ¡Se ha producido un error!',
    productRelations: 'Productos recomendados',
  },
  'en-GB': {
    writeAReview: 'Be the first to review this product',
    productCode: 'Product code: {code}',
    paymentsInfoKlarnaPayPal:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong>Klarna</strong>&nbsp;<strong><em>PayPal</em></strong>',
    paymentsInfoKlarna:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong>Klarna</strong>',
    paymentsInfoPayPal:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong><em>PayPal</em></strong>',
    paymentsInfoTextHeader:
      'Buy now and pay in 3 rates of {amount} without interests.',
    paymentsInfoTextKlarnaPayPal:
      '<li>Add items into the cart.</li><li>Go to checkout and choose <strong>Klarna</strong> or <strong>PayPal</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining ones will be made every 30 days.</li>',
    paymentsInfoTextKlarna:
      '<li>Add items into the cart</li><li>Go to checkout and choose <strong>Klarna</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining payments will be made every 30 days.</li>',
    paymentsInfoTextPayPal:
      '<li>Add items into the cart</li><li>Go to checkout and choose <strong>PayPal</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining payments will be made every 30 days.</li>',
    paymentsInfoKlarnaPayPalFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link1} target="_blank">Klarna\'s terms and conditions</a> and <a class="link" href={link2} target="_blank">PayPal\'s terms and conditions</a> for more information.',
    paymentsInfoKlarnaFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link} target="_blank">Klarna\'s terms and conditions</a> for more information.',
    paymentsInfoPayPalFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link} target="_blank">Paypal\'s terms and conditions</a> for more information.',
    paymentsInfoButtonClose: 'Close',
    oneOrMoreComponentUnavailable:
      'Please note: one or more products are not currently available.',
    untilDepletion: 'Limited quantity available',
    productKitIncludes: 'The product includes:',
    oneUnit: '1 product',
    fromXToY: 'from {x} to {y}} units:',
    moreThan: '{x} or more units',
    sizeChart: 'Size chart',
    select: 'Select',
    selectSize: 'Select a size',
    moreThanFive: 'More than 5',
    moreThanTen: 'More than 10',
    availability: {
      available: 'Available',
      oneAvailable: 'Only 1 available',
      unavailable: 'Not available',
      booking: 'On order',
      comingSoon: 'Coming Soon',
      preorder: 'On pre-order',
    },
    availabilityNote: {
      available:
        "<span class='prd-availability-colored'>{qty} available.</span> {shippingMessage}",
      oneAvailable:
        "<span class='prd-availability-colored'>Only 1 available.</span> {shippingMessage}",
      unavailable:
        "<span class='prd-availability-colored'>Not available.</span> The selected product is currently not available.",
      qtyUnavailable:
        "<span class='prd-availability-colored'>Not available.</span> The quantity selected is not currently available.",
      optionUnavailable:
        "<span class='prd-availability-colored'>Not available.</span> This item is not available.",
      preorder:
        "<span class='prd-availability-colored'>On pre-order.</span>Pre-order the product now to receive it as soon as it is available.<br />Estimated date of arrival:  {date}.",
      booking:
        "<span class='prd-availability-colored'>Available in {days} days.</span> The selected option is on request: <a class='link' href='{pathBase}help/returns-and-refunds-european-union-member-countries#product-on-request'>read the conditions</a>.",
      soonAvailable:
        "<span class='prd-availability-colored'>Available in {days} days.</span> The selected option is on request: <a class='link' href='{pathBase}help/returns-and-refunds-european-union-member-countries#product-on-request'>read the conditions</a>.",
      comingSoon:
        "<span class='prd-availability-colored'>Coming soon.</span> The option is coming soon.<br />Estimated date of arrival: {date}.",
      discontinued:
        "<span class='prd-availability-colored'><span class='prd-availability-colored'>Discontinued.</span> We are sorry, but the selected product is no longer in stock.",
      qtyDiscontinued:
        "<span class='prd-availability-colored'><span class='prd-availability-colored'>Discontinued.</span> Unfortunately the selected quantity will no longer be available.",
    },
    selectionHint:
      'The following fields have not been filled in: <strong>{attr}</strong>.',
    logInToAddReassNotification:
      '<a href={url} class="prd-link">Log in</a> and sign up to be notified when the product is back in stock.',
    fastShippingHHMM:
      'Order within {hh} and {mm}  and we will send your parcel today.',
    fastShippingHH: 'Order within {hh} and we will send your parcel today',
    fastShippingMM: 'Order within {mm} and we will send your parcel today',
    shippingDate: 'Your order will be sent out on {date}.',
    time: {
      hour: 'hour',
      hours: 'hours',
      minute: 'minute',
      minutes: 'minutes',
    },
    quantity: 'Quantity',
    buyOn: 'Buy now on lordgun.com',
    addToCart: 'Add to cart',
    unavailableNote:
      'The quantity selected is not currently available. Would you like to know when this item will be back in stock?',
    activateReassortMentNotification: 'Activate the stock alert',
    freeShipping: 'Free shipping',
    freeShippings: 'Free Shippings',
    freeShippingsNote: 'For orders over {price}',
    securePayments: 'Secure Payments',
    securePaymentsNote: 'We care about your security',
    fastDispatch: 'Fast Dispatch',
    fastDispatchNote: 'In 24h for orders placed before 2.00 p.m. GMT+1',
    automatedTranslation: {
      translated: 'This text has been automatically translated.',
      original: 'An automatic translation is available for this text.',
    },
    seeOriginal: 'Click here to read the original.',
    backToTranslation: 'View automatic translation.',
    tabs: {
      description: 'Description',
      techSpecs: 'Specifications',
      technologies: 'Technologies',
      brandsGuides: 'Size chart',
      reviews: 'Reviews',
      qAndA: 'Questions and answers',
      top: 'Top',
      news: 'news',
    },
    isUseful: 'Useful?',
    yes: 'Yes',
    no: 'No',
    vulgar: 'Rude',
    spam: 'Spam',
    useless: 'Useless',
    send: 'Send',
    cart: {
      label: {
        available: 'Product added to cart!',
        soonAvailable: 'Product added to cart!',
        oneAvailable: 'Product added to cart!',
        unavailable: 'Stock alert added!',
        qtyUnavailable: 'Stock alert added!',
        optionUnavailable: '',
        preorder: 'Product added to cart!',
        booking: 'Product added to cart!',
        comingSoon: 'Product added to cart!',
        discontinued: '',
      },
      itemsInCart: 'Items in cart',
      totalPrice: 'Total price',
      goToCart: 'Go to cart',
      goToNotifications: 'Go to notifications',
      continueShopping: 'Continue shopping',
    },
    genericError: 'Oops... a problem has occurred!',
    productRelations: 'Also recommended',
  },
  'en-US': {
    writeAReview: 'Be the first to review this product',
    productCode: 'Product code: {code}',
    paymentsInfoKlarnaPayPal:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong>Klarna</strong>&nbsp;<strong><em>PayPal</em></strong>',
    paymentsInfoKlarna:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong>Klarna</strong>',
    paymentsInfoPayPal:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong><em>PayPal</em></strong>',
    paymentsInfoTextHeader:
      'Buy now and pay in 3 rates of {amount} without interests.',
    paymentsInfoTextKlarnaPayPal:
      '<li>Add items into the cart.</li><li>Go to checkout and choose <strong>Klarna</strong> or <strong>PayPal</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining ones will be made every 30 days.</li>',
    paymentsInfoTextKlarna:
      '<li>Add items into the cart</li><li>Go to checkout and choose <strong>Klarna</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining payments will be made every 30 days.</li>',
    paymentsInfoTextPayPal:
      '<li>Add items into the cart</li><li>Go to checkout and choose <strong>PayPal</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining payments will be made every 30 days.</li>',
    paymentsInfoKlarnaPayPalFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link1} target="_blank">Klarna\'s terms and conditions</a> and <a class="link" href={link2} target="_blank">PayPal\'s terms and conditions</a> for more information.',
    paymentsInfoKlarnaFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link} target="_blank">Klarna\'s terms and conditions</a> for more information.',
    paymentsInfoPayPalFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link} target="_blank">Paypal\'s terms and conditions</a> for more information.',
    paymentsInfoButtonClose: 'Close',
    oneOrMoreComponentUnavailable:
      'Please note: one or more products are not currently available.',
    untilDepletion: 'Limited quantity available',
    productKitIncludes: 'The product includes:',
    oneUnit: '1 product',
    fromXToY: 'from {x} to {y}} units:',
    moreThan: '{x} or more units',
    sizeChart: 'Size chart',
    select: 'Select',
    selectSize: 'Select a size',
    moreThanFive: 'More than 5',
    moreThanTen: 'More than 10',
    availability: {
      available: 'Available',
      oneAvailable: 'Only 1 available',
      unavailable: 'Not available',
      booking: 'On order',
      comingSoon: 'Coming Soon',
      preorder: 'On pre-order',
    },
    availabilityNote: {
      available:
        "<span class='prd-availability-colored'>{qty} available.</span> {shippingMessage}",
      oneAvailable:
        "<span class='prd-availability-colored'>Only 1 available.</span> {shippingMessage}",
      unavailable:
        "<span class='prd-availability-colored'>Not available.</span> The selected product is currently not available.",
      qtyUnavailable:
        "<span class='prd-availability-colored'>Not available.</span> The quantity selected is not currently available.",
      optionUnavailable:
        "<span class='prd-availability-colored'>Not available.</span> This item is not available.",
      preorder:
        "<span class='prd-availability-colored'>On pre-order.</span>Pre-order the product now to receive it as soon as it is available.<br />Estimated date of arrival:  {date}.",
      booking:
        "<span class='prd-availability-colored'>Available in {days} days.</span> The selected option is on request: <a class='link' href='{pathBase}help/returns-and-refunds-european-union-member-countries#product-on-request'>read the conditions</a>.",
      soonAvailable:
        "<span class='prd-availability-colored'>Available in {days} days.</span> The selected option is on request: <a class='link' href='{pathBase}help/returns-and-refunds-european-union-member-countries#product-on-request'>read the conditions</a>.",
      comingSoon:
        "<span class='prd-availability-colored'>Coming soon.</span> The option is coming soon.<br />Estimated date of arrival: {date}.",
      discontinued:
        "<span class='prd-availability-colored'><span class='prd-availability-colored'>Discontinued.</span> We are sorry, but the selected product is no longer in stock.",
      qtyDiscontinued:
        "<span class='prd-availability-colored'><span class='prd-availability-colored'>Discontinued.</span> Unfortunately the selected quantity will no longer be available.",
    },
    selectionHint:
      'The following fields have not been filled in: <strong>{attr}</strong>.',
    logInToAddReassNotification:
      '<a href={url} class="prd-link">Log in</a> and sign up to be notified when the product is back in stock.',
    fastShippingHHMM:
      'Order within {hh} and {mm}  and we will send your parcel today.',
    fastShippingHH: 'Order within {hh} and we will send your parcel today',
    fastShippingMM: 'Order within {mm} and we will send your parcel today',
    shippingDate: 'Your order will be sent out on {date}.',
    time: {
      hour: 'hour',
      hours: 'hours',
      minute: 'minute',
      minutes: 'minutes',
    },
    quantity: 'Quantity',
    buyOn: 'Buy now on lordgun.com',
    addToCart: 'Add to cart',
    unavailableNote:
      'The quantity selected is not currently available. Would you like to know when this item will be back in stock?',
    activateReassortMentNotification: 'Activate the stock alert',
    freeShipping: 'Free shipping',
    freeShippings: 'Free Shippings',
    freeShippingsNote: 'For orders over {price}',
    securePayments: 'Secure Payments',
    securePaymentsNote: 'We care about your security',
    fastDispatch: 'Fast Dispatch',
    fastDispatchNote: 'In 24h for orders placed before 2.00 p.m. GMT+1',
    automatedTranslation: {
      translated: 'This text has been automatically translated.',
      original: 'An automatic translation is available for this text.',
    },
    seeOriginal: 'Click here to read the original.',
    backToTranslation: 'View automatic translation.',
    tabs: {
      description: 'Description',
      techSpecs: 'Specifications',
      technologies: 'Technologies',
      brandsGuides: 'Size chart',
      reviews: 'Reviews',
      qAndA: 'Questions and answers',
      top: 'Top',
      news: 'news',
    },
    isUseful: 'Useful?',
    yes: 'Yes',
    no: 'No',
    vulgar: 'Rude',
    spam: 'Spam',
    useless: 'Useless',
    send: 'Send',
    cart: {
      label: {
        available: 'Product added to cart!',
        soonAvailable: 'Product added to cart!',
        oneAvailable: 'Product added to cart!',
        unavailable: 'Stock alert added!',
        qtyUnavailable: 'Stock alert added!',
        optionUnavailable: '',
        preorder: 'Product added to cart!',
        booking: 'Product added to cart!',
        comingSoon: 'Product added to cart!',
        discontinued: '',
      },
      itemsInCart: 'Items in cart',
      totalPrice: 'Total price',
      goToCart: 'Go to cart',
      goToNotifications: 'Go to notifications',
      continueShopping: 'Continue shopping',
    },
    genericError: 'Oops... a problem has occurred!',
    productRelations: 'Also recommended',
  },
  'de-DE': {
    writeAReview: 'Schreiben Sie die erste Rezension',
    productCode: 'Produktcode: {code}',
    paymentsInfoKlarnaPayPal:
      'Zahlung in 3 Raten <strong>{amount}</strong> ohne Zinsen.<strong>Klarna</strong>&nbsp;<strong><em>PayPal</em></strong>',
    paymentsInfoKlarna:
      'Zahlung in 3 Raten <strong>{amount}</strong> ohne Zinsen. <strong>Klarna</strong>',
    paymentsInfoPayPal:
      'Zahlung in 3 Raten <strong>{amount}</strong> ohne Zinsen.  <strong><em>PayPal</em></strong>',
    paymentsInfoTextHeader:
      'Kaufen Sie jetzt und zahlen Sie in 3 Raten von {amount} ohne Zinsen.',
    paymentsInfoTextKlarnaPayPal:
      '<li>Legen Sie die Artikel in den Warenkorb.</li><li>Gehen Sie zur Kasse und wählen Sie  <strong>Klarna</strong> oder <strong>PayPal</strong>.</li><li>Wählen Sie die Option, in 3 zinslosen Raten zu zahlen, und geben Sie Ihre Debit- oder Kreditkartendaten ein.</li><li>Zahlen Sie in Raten. Die erste Zahlung erfolgt bei der Bearbeitung der Bestellung, die weiteren Raten werden alle 30 Tage gezahlt.</li>',
    paymentsInfoTextKlarna:
      '<li>Legen Sie die Artikel in den Warenkorb</li><li>Gehen Sie zur Kasse und wählen Sie <strong>Klarna</strong>.</li><li>Wählen Sie die Option, in 3 zinslosen Raten zu zahlen, und geben Sie Ihre Debit- oder Kreditkartendaten ein.</li><li>Zahlen Sie in Raten. Die erste Zahlung erfolgt bei der Bearbeitung der Bestellung, die weiteren Raten werden alle 30 Tage gezahlt.</li>',
    paymentsInfoTextPayPal:
      '<li>Legen Sie die Artikel in den Warenkorb</li><li>Gehen Sie zur Kasse und wählen Sie <strong>PayPal</strong>.</li><li>Wählen Sie die Option, in 3 zinslosen Raten zu zahlen, und geben Sie Ihre Debit- oder Kreditkartendaten ein.</li><li>Zahlen Sie in Raten. Die erste Zahlung erfolgt bei der Bearbeitung der Bestellung, die weiteren Raten werden alle 30 Tage gezahlt.</li>',
    paymentsInfoKlarnaPayPalFooter:
      'Bitte beachten Sie, dass für einige Käufe eine höhere Anzahlung erforderlich sein kann. Weitere Informationen finden Sie in den Allgemeinen Geschäftsbedingungen von  <a class="link" href={link1} target="_blank">Klarna</a> und <a class="link" href={link2} target="_blank">PayPal</a>.',
    paymentsInfoKlarnaFooter:
      'Bitte beachten Sie, dass für einige Käufe eine höhere Anzahlung erforderlich sein kann. Weitere Informationen finden Sie in den Allgemeinen Geschäftsbedingungen von  <a class="link" href={link} target="_blank">Klarna</a>',
    paymentsInfoPayPalFooter:
      'Bitte beachten Sie, dass für einige Käufe eine höhere Anzahlung erforderlich sein kann. Weitere Informationen finden Sie in den Allgemeinen Geschäftsbedingungen von  <a class="link" href={link} target="_blank">PayPal</a>',
    paymentsInfoButtonClose: 'Schließen',
    oneOrMoreComponentUnavailable:
      'Bitte beachten Sie: Ein oder mehrere Produkte sind derzeit nicht verfügbar.',
    untilDepletion: 'Auslaufender Artikel',
    productKitIncludes: 'Das Produkt enthält:',
    oneUnit: '1 Artikel',
    fromXToY: 'von {x} bis {y} Einheiten:',
    moreThan: '{x} oder mehr Einheiten',
    sizeChart: 'Größen-Tabelle',
    select: 'Auswahl',
    selectSize: 'Größe wählen',
    moreThanFive: 'Mehr als 5',
    moreThanTen: 'Mehr als 10',
    availability: {
      available: 'Verfügbar',
      oneAvailable: 'Nur 1 verfügbar',
      unavailable: 'Nicht verfügbar',
      booking: 'Auf Bestellung',
      comingSoon: 'Coming Soon',
      preorder: 'Auf Vorbestellung',
    },
    availabilityNote: {
      available:
        "<span class='prd-availability-colored'>{qty} verfügbar.</span> {shippingMessage}",
      oneAvailable:
        "<span class='prd-availability-colored'>Nur 1 verfügbar.</span> {shippingMessage}",
      unavailable:
        "<span class='prd-availability-colored'>Nicht verfügbar.</span> Das gewünschte Produkt ist aktuell nicht verfügbar.",
      qtyUnavailable:
        "<span class='prd-availability-colored'>Nicht verfügbar.</span> Die gewünschte Menge ist aktuell nicht verfügbar.",
      optionUnavailable:
        "<span class='prd-availability-colored'>Nicht verfügbar.</span> Dieser Artikel ist nicht verfügbar.",
      preorder:
        "<span class='prd-availability-colored'>Auf Vorbestellung.</span>Bestellen Sie das Produkt jetzt vor, um es zu erhalten, sobald es verfügbar ist.<br />Geschätztes Ankunftsdatum: {date}.",
      booking:
        "<span class='prd-availability-colored'>Verfügbar in {days} Tagen.</span> Die ausgewählte Option ist auf Bestellung: <a class='link' href='{pathBase}hilfe/rückgaben-und-rückerstattungen-eu-länder#product-on-request'>Lesen Sie die Bedingungen</a>.",
      soonAvailable:
        "<span class='prd-availability-colored'>Verfügbar in {days} Tagen.</span> Die ausgewählte Option ist auf Bestellung: <a class='link' href='{pathBase}hilfe/rückgaben-und-rückerstattungen-eu-länder#product-on-request'>Lesen Sie die Bedingungen</a>.",
      comingSoon:
        "<span class='prd-availability-colored'>Bald verfügbar.</span> Die Option ist bald verfügbar.<br />Geschätztes Ankunftsdatum: {date}.",
      discontinued:
        "<span class='prd-availability-colored'>Nicht mehr verfügbar.</span> Es tut uns leid, aber das ausgewählte Produkt ist nicht mehr auf Lager.",
      qtyDiscontinued:
        "<span class='prd-availability-colored'>Nicht mehr verfügbar.</span> Es tut uns Leid, aber die gewünschte Menge wird nicht nachbestellt.",
    },
    selectionHint:
      'Die folgenden Felder wurden nicht ausgefüllt: <strong>{attr}</strong>.',
    logInToAddReassNotification:
      '<a href={url} class="prd-link">Loggen Sie sich ein</a> um die Verfügbarkeitsbenachrichtigung zu aktivieren.',
    fastShippingHHMM:
      'Bestellen Sie binnen {hh} und {mm} und wir werden Ihr Paket heute verschicken.',
    fastShippingHH:
      'Bestellen Sie binnen {hh} und wir werden Ihr Paket heute verschicken.',
    fastShippingMM:
      'Bestellen Sie binnen {mm} und wir werden Ihr Paket heute verschicken.',
    shippingDate: 'Die Ware wird {date} versandt.',
    time: {
      hour: 'Stunde',
      hours: 'Stunden',
      minute: 'Minute',
      minutes: 'Minuten',
    },
    quantity: 'Menge',
    buyOn: 'Jetzt bei lordgun.com kaufen',
    addToCart: 'In den Warenkorb',
    unavailableNote:
      'Die gewünschte Menge ist aktuell nicht verfügbar. Möchten Sie wissen, wann das Produkt wieder im Lager erscheint?',
    activateReassortMentNotification: 'Benachrichtigen, wenn verfügbar',
    freeShipping: 'Kostenlose Lieferung',
    freeShippings: 'Kostenlose Lieferung',
    freeShippingsNote: 'Von Bestellungen ab  {price}',
    securePayments: 'Sichere Zahlung',
    securePaymentsNote: 'Wir kümmern uns um Ihre Sicherheit',
    fastDispatch: 'Blitzversand',
    fastDispatchNote: 'Innerhalb von 24h bei Bestellungen bis 14 Uhr',
    automatedTranslation: {
      translated: 'Dieser Text wurde automatisch übersetzt.',
      original: 'Für diesen Text ist eine automatische Übersetzung verfügbar.',
    },
    seeOriginal: 'Klicken Sie hier, um das Original zu lesen.',
    backToTranslation: 'Automatische Übersetzung anzeigen.',
    tabs: {
      description: 'Beschreibung',
      techSpecs: 'Technische Daten',
      technologies: 'Technologien',
      brandsGuides: 'Größen-Tabelle',
      reviews: 'Rezensionen',
      qAndA: 'Fragen und Antworten',
      top: 'Top',
      news: 'news',
    },
    isUseful: 'Nützlich?',
    yes: 'Ja',
    no: 'Nein',
    vulgar: 'Vulgär',
    spam: 'Spam',
    useless: 'Unbrauchbar',
    send: 'Senden',
    cart: {
      label: {
        available: 'Produkt zum Warenkorb hinzugefügt!',
        soonAvailable: 'Produkt zum Warenkorb hinzugefügt!',
        oneAvailable: 'Produkt zum Warenkorb hinzugefügt!',
        unavailable: 'Bestandsalarm aktiviert!',
        qtyUnavailable: 'Bestandsalarm aktiviert!',
        optionUnavailable: '',
        preorder: 'Produkt zum Warenkorb hinzugefügt!',
        booking: 'Produkt zum Warenkorb hinzugefügt!',
        comingSoon: 'Produkt zum Warenkorb hinzugefügt!',
        discontinued: '',
      },
      itemsInCart: 'Artikel im Warenkorb',
      totalPrice: 'Gesamtpreis',
      goToCart: 'Zum Warenkorb wechseln',
      goToNotifications: 'Zu den Benachrichtigungen wechseln',
      continueShopping: 'Weiter einkaufen',
    },
    genericError: 'Es ist ein Fehler aufgetreten!',
    productRelations: 'Ähnliche Produkte',
  },
  'en-AU': {
    writeAReview: 'Be the first to review this product',
    productCode: 'Product code: {code}',
    paymentsInfoKlarnaPayPal:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong>Klarna</strong>&nbsp;<strong><em>PayPal</em></strong>',
    paymentsInfoKlarna:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong>Klarna</strong>',
    paymentsInfoPayPal:
      'Pay in 3 rates of <strong>{amount}</strong> without interests. <strong><em>PayPal</em></strong>',
    paymentsInfoTextHeader:
      'Buy now and pay in 3 rates of {amount} without interests.',
    paymentsInfoTextKlarnaPayPal:
      '<li>Add items into the cart.</li><li>Go to checkout and choose <strong>Klarna</strong> or <strong>PayPal</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining ones will be made every 30 days.</li>',
    paymentsInfoTextKlarna:
      '<li>Add items into the cart</li><li>Go to checkout and choose <strong>Klarna</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining payments will be made every 30 days.</li>',
    paymentsInfoTextPayPal:
      '<li>Add items into the cart</li><li>Go to checkout and choose <strong>PayPal</strong>.</li><li>Select the option to pay in 3 interest-free installments and enter your debit or credit card details.</li><li>Pay in rates. The first payment will be made when the order is processed, and the remaining payments will be made every 30 days.</li>',
    paymentsInfoKlarnaPayPalFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link1} target="_blank">Klarna\'s terms and conditions</a> and <a class="link" href={link2} target="_blank">PayPal\'s terms and conditions</a> for more information.',
    paymentsInfoKlarnaFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link} target="_blank">Klarna\'s terms and conditions</a> for more information.',
    paymentsInfoPayPalFooter:
      'Please note that a higher initial payment may be required for some purchases. Check <a class="link" href={link} target="_blank">Paypal\'s terms and conditions</a> for more information.',
    paymentsInfoButtonClose: 'Close',
    oneOrMoreComponentUnavailable:
      'Please note: one or more products are not currently available.',
    untilDepletion: 'Limited quantity available',
    productKitIncludes: 'The product includes:',
    oneUnit: '1 product',
    fromXToY: 'from {x} to {y}} units:',
    moreThan: '{x} or more units',
    sizeChart: 'Size chart',
    select: 'Select',
    selectSize: 'Select a size',
    moreThanFive: 'More than 5',
    moreThanTen: 'More than 10',
    availability: {
      available: 'Available',
      oneAvailable: 'Only 1 available',
      unavailable: 'Not available',
      booking: 'On order',
      comingSoon: 'Coming Soon',
      preorder: 'On pre-order',
    },
    availabilityNote: {
      available:
        "<span class='prd-availability-colored'>{qty} available.</span> {shippingMessage}",
      oneAvailable:
        "<span class='prd-availability-colored'>Only 1 available.</span> {shippingMessage}",
      unavailable:
        "<span class='prd-availability-colored'>Not available.</span> The selected product is currently not available.",
      qtyUnavailable:
        "<span class='prd-availability-colored'>Not available.</span> The quantity selected is not currently available.",
      optionUnavailable:
        "<span class='prd-availability-colored'>Not available.</span> This item is not available.",
      preorder:
        "<span class='prd-availability-colored'>On pre-order.</span>Pre-order the product now to receive it as soon as it is available.<br />Estimated date of arrival:  {date}.",
      booking:
        "<span class='prd-availability-colored'>Available in {days} days.</span> The selected option is on request: <a class='link' href='{pathBase}help/returns-and-refunds-european-union-member-countries#product-on-request'>read the conditions</a>.",
      soonAvailable:
        "<span class='prd-availability-colored'>Available in {days} days.</span> The selected option is on request: <a class='link' href='{pathBase}help/returns-and-refunds-european-union-member-countries#product-on-request'>read the conditions</a>.",
      comingSoon:
        "<span class='prd-availability-colored'>Coming soon.</span> The option is coming soon.<br />Estimated date of arrival: {date}.",
      discontinued:
        "<span class='prd-availability-colored'><span class='prd-availability-colored'>Discontinued.</span> We are sorry, but the selected product is no longer in stock.",
      qtyDiscontinued:
        "<span class='prd-availability-colored'><span class='prd-availability-colored'>Discontinued.</span> Unfortunately the selected quantity will no longer be available.",
    },
    selectionHint:
      'The following fields have not been filled in: <strong>{attr}</strong>.',
    logInToAddReassNotification:
      '<a href={url} class="prd-link">Log in</a> and sign up to be notified when the product is back in stock.',
    fastShippingHHMM:
      'Order within {hh} and {mm}  and we will send your parcel today.',
    fastShippingHH: 'Order within {hh} and we will send your parcel today',
    fastShippingMM: 'Order within {mm} and we will send your parcel today',
    shippingDate: 'Your order will be sent out on {date}.',
    time: {
      hour: 'hour',
      hours: 'hours',
      minute: 'minute',
      minutes: 'minutes',
    },
    quantity: 'Quantity',
    buyOn: 'Buy now on lordgun.com',
    addToCart: 'Add to cart',
    unavailableNote:
      'The quantity selected is not currently available. Would you like to know when this item will be back in stock?',
    activateReassortMentNotification: 'Activate the stock alert',
    freeShipping: 'Free shipping',
    freeShippings: 'Free Shippings',
    freeShippingsNote: 'For orders over {price}',
    securePayments: 'Secure Payments',
    securePaymentsNote: 'We care about your security',
    fastDispatch: 'Fast Dispatch',
    fastDispatchNote: 'In 24h for orders placed before 2.00 p.m. GMT+1',
    automatedTranslation: {
      translated: 'This text has been automatically translated.',
      original: 'An automatic translation is available for this text.',
    },
    seeOriginal: 'Click here to read the original.',
    backToTranslation: 'View automatic translation.',
    tabs: {
      description: 'Description',
      techSpecs: 'Specifications',
      technologies: 'Technologies',
      brandsGuides: 'Size chart',
      reviews: 'Reviews',
      qAndA: 'Questions and answers',
      top: 'Top',
      news: 'news',
    },
    isUseful: 'Useful?',
    yes: 'Yes',
    no: 'No',
    vulgar: 'Rude',
    spam: 'Spam',
    useless: 'Useless',
    send: 'Send',
    cart: {
      label: {
        available: 'Product added to cart!',
        soonAvailable: 'Product added to cart!',
        oneAvailable: 'Product added to cart!',
        unavailable: 'Stock alert added!',
        qtyUnavailable: 'Stock alert added!',
        optionUnavailable: '',
        preorder: 'Product added to cart!',
        booking: 'Product added to cart!',
        comingSoon: 'Product added to cart!',
        discontinued: '',
      },
      itemsInCart: 'Items in cart',
      totalPrice: 'Total price',
      goToCart: 'Go to cart',
      goToNotifications: 'Go to notifications',
      continueShopping: 'Continue shopping',
    },
    genericError: 'Oops... a problem has occurred!',
    productRelations: 'Also recommended',
  },
};
